import { CarsFoundForms } from 'features/filter/components'
import { createPluralFormWithPlaceholder } from 'lib/pluralize'
import { useMemo } from 'react'

export const useCarsFoundText = (
  carsFound: number,
  maxVisibleCount: number | undefined,
  carsFoundForms: CarsFoundForms
) => {
  return useMemo(() => {
    const isCarsCountExceed = (maxVisibleCount: number | undefined): maxVisibleCount is number => {
      return maxVisibleCount !== undefined && carsFound !== null && carsFound > maxVisibleCount
    }

    let cappedCarsCount: number

    if (isCarsCountExceed(maxVisibleCount)) {
      cappedCarsCount = maxVisibleCount
    } else {
      cappedCarsCount = carsFound
    }

    return createPluralFormWithPlaceholder(carsFoundForms, cappedCarsCount, (value: number) => {
      if (isCarsCountExceed(maxVisibleCount)) {
        return `${value}+`
      } else {
        return value.toString()
      }
    })
  }, [carsFound, carsFoundForms, maxVisibleCount])
}
